import { CountdownBar } from '@frontend/ui-library';

export interface WidgetHeaderCountdownBarProps {
  className?: string;
  color?: 'default' | 'warning';
  expiresAt: number;
  startedAt: number;
}

export default function WidgetHeaderCountdownBar({
  className,
  color,
  expiresAt,
  startedAt,
}: WidgetHeaderCountdownBarProps): JSX.Element {
  const now = Date.now();

  const percentage = Math.floor(
    ((expiresAt * 1000 - now) / (expiresAt * 1000 - startedAt * 1000)) * 100
  );

  const duration = expiresAt * 1000 - now;

  return (
    <CountdownBar
      color={color}
      className={className}
      state="playing"
      duration={duration}
      startingPercentage={percentage}
    />
  );
}
